import React from 'react';
/**
 * AutoLayout Component
 */
const AutoLayout = ({ children }) => {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, children);
};
export default AutoLayout;
//# sourceMappingURL=AutoLayout.js.map